<template>
  <div class="bigBody" id="index">
    <!-- <div style="width: 260px" id="bodyleft" >
      <myleft :minHeight="minHeight"></myleft>
    </div> -->
    <div :style="{'height': minHeight + 50 + 'px'}" style="width: calc(100%)" id="bodyright">
      <!--<newHelp style="z-index: 1000"></newHelp>-->
<!--      <transition name="fadeLeft">-->
<!--        <router-view></router-view>-->
<!--      </transition>-->
    <router-view></router-view>
    </div>
  </div>
</template>

<script>
import left from '../left-menu/menu'
let timeout
export default {
  name: 'index',
  data () {
    return {
      minHeight: 1080,
      loginName: ''
    }
  },
  destroyed () {
    clearInterval(timeout)
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    console.log(document.getElementById('index').clientHeight)
    this.minHeight = window.innerHeight - 55
    this.$nextTick(p => {
      // if (this.minHeight <= (document.getElementById('index').clientHeight - (this.$isiPad ? 150 : 100))) {
      //   document.getElementById('bodyright').style.height = 'auto'
      // }
    })
    timeout = setInterval(p => {
      this.minHeight = window.innerHeight - 55
    }, 1000)
    // window.onresize = e => {
    //   console.log(11111111111)
    //   clearTimeout(timeout)
    //   timeout = setTimeout(p => {
    //     console.log(e)
    //     this.minHeight = window.innerHeight - 55
    //     this.$nextTick(p => {
    //       // if (this.minHeight <= (document.getElementById('index').clientHeight - 100)) {
    //       //   document.getElementById('bodyright').style.height = 'auto'
    //       // }
    //     })
    //   }, 1000)
    // }
  },
  methods: {
    returnOverflow () {
      if (this.$route.name === 'AllDetails' || this.$route.name === 'NonPoAll') {
        return 'hidden!important'
      }
    },
    returnWidth (type) {
      let windowWidth = window.screen.width
      if (type === 1) {
        // if (this.$isiPad) {
        //   return '80px'
        // } else {
        //   return '260px'
        // }
        if (this.$route.name === 'AllDetails' || this.$route.name === 'NonPoAll') {
          return '0px'
        } else {
          if (this.$isiPad || windowWidth < 500) {
            return '80px'
          } else {
            return '260px'
          }
        }
      } else {
        // if (this.$isiPad) {
        //   return 'calc(100% - 80px)'
        // } else {
        //   return 'calc(100% - 260px)'
        // }
        if (this.$route.name === 'AllDetails' || this.$route.name === 'NonPoAll') {
          return '100%'
        } else {
          if (this.$isiPad || windowWidth < 500) {
            return 'calc(100% - 80px)'
          } else {
            return 'calc(100% - 260px)'
          }
        }
      }
    }
  },
  components: {
    'myleft': left
  }
}
</script>

<style scoped>
  .userInfo{
    text-align: center;
    width: 100%;
    margin-top: 5%;
    /*position: absolute;*/
    margin-bottom: 10px;
    color: #999;
  }
  .userInfo p i{
    color: #C73343;
  }
  .userInfo p:nth-child(2){
    margin-top: 10px;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/myIndex/index.vue